import React, { useState, useEffect } from "react";
import logo from "assets/img/reteam_logo.png";
import CustomInput from "components/CustomInput/CustomInput";
import email_image from "assets/img/email_code.png";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "components/CustomButton";
import Loader from "components/Loader";
import * as Yup from "yup";
import "assets/scss/partials/authentication.scss";
import * as microsoftTeams from "@microsoft/teams-js";
import "assets/scss/base/custom.scss";
import { useFormik } from "formik";
import { useUserContext } from "store/contexts/userContext";
import AuthService from "services/AuthService";
import { useCredentialsContext } from "store/contexts/credentialsContext";
import { Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGlobalContext } from "store/contexts/globalContext";
import useCountDownTimer from "hooks/useCountDownTimer";
import { useToasts } from "react-toast-notifications";

var styles = {
  emailImage: {
    width: "45%",
    maxWidth: "15%",
  },
  codeInformation: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: "5px",
  },
  mailText: {
    color: "#3f51b5",
    fontWeight: "400",
  },
  alertText: {
    color: "#f44336",
    fontWeight: "400",
  },
  time: {
    color: "#fea000",
    fontSize: "25px",
    fontWeight: "500",
    padding: "15px 0px",
  },
  disableResend: {
    pointerEvents: "none",
    cursor: "default",
    color: "gray",
    margin: "3px",
  },
  enableResend: {
    pointerEvents: "all",
    cursor: "pointer",
    color: "#bf780e",
    textDecoration: "underline",
    margin: "3px",
  },
  recieveCodeText: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 0px",
  },
};

export default () => {
  const classes = styles;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { setIsAuthenticated } = useUserContext();
  const { credentials, setCredentials } = useCredentialsContext();
  const history = useHistory();
  const [disableResendCode, setDisableResendCode] = useState(true);
  const { ringCentral, redirectUrl } = useGlobalContext();
  const { addToast } = useToasts();
  const { date } = useCountDownTimer({
    setDisableResendCode,
    disableResendCode,
  });

  useEffect(() => {
    if (!credentials) {
      history.replace("/login");
    }

    microsoftTeams.app.initialize();
    microsoftTeams.app.notifySuccess();

    //eslint-disable-next-line
  }, [credentials, history]);

  const formik = useFormik({
    initialValues: {
      code: "",
    },
    validationSchema: verificationValidationSchema(),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const {
          data: { data: userData },
        } = await AuthService.verifyAccount({
          email: credentials.email,
          verification_code: values.code,
        });

        if (userData.status === "unapproved") {
          setBlackListLogin();
          return;
        }

        setLogin(userData);

        if (ringCentral) {
          history.push(`${redirectUrl}`);
        }
      } catch (error) {
        if (error.response) {
          setErrorState(
            error.response?.data.errors?.verification_code[0] ??
              error.response.data.message
          );
        }
      }
      setLoading(false);
    },
  });

  const setErrorState = (message) => {
    setErrorMessage(message);
    setTimeout((_) => {
      setErrorMessage("");
    }, 4000);
  };

  const setBlackListLogin = () => {
    setCredentials(null);
    history.push("/");
    addToast(
      "Your request for access has been forwarded, One of our representatives will contact you.",
      { appearance: "success" }
    );
  };

  const setLogin = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", user.token);

    setIsAuthenticated(true);
    setCredentials(null);
  };

  const resendCode = async (event) => {
    event.preventDefault();
    await AuthService.resendVerificationCode(credentials.email);
    setDisableResendCode(true);
  };

  return (
    <div className="root" id="user_login">
      <div className="inputBox">
        <div className="login_logo textcenter">
          <img className="logo" alt="ReTeam Logo" src={logo} />
        </div>
        <div className="content">
          <div className="textcenter heading">ReTeam Verify Account</div>
          <div style={classes.codeInformation}>
            <div>
              <img
                src={email_image}
                alt="email_image"
                style={classes.emailImage}
              />
            </div>
            <div>We have sent you a code on {credentials?.email}</div>
            <div style={classes.mailText}>
            Please check your inbox and spam too for the mail
            </div>
            <div style={classes.alertText}>
              If you haven't received the email please wait for 20 minutes.
            </div>
            <div style={classes.time}>{date}</div>
          </div>
          <div className="formContent">
            <form noValidate onSubmit={formik.handleSubmit}>
              <div className="inputFields">
                <CustomInput
                  id={"verification-code"}
                  startIcon={
                    <FontAwesomeIcon icon={faEnvelope} className="formIcon" />
                  }
                  inputProps={{
                    type: "text",
                    placeholder: "Please write the verification code",
                    ...formik.getFieldProps("code"),
                    error: formik.errors.code,
                  }}
                />
                {errorMessage && (
                  <div className="errorMessage">{errorMessage}</div>
                )}
              </div>
              <CustomButton
                name={!loading ? "Verify" : <Loader width={40} height={40} />}
                disabled={loading && true}
              />
            </form>
          </div>
          <div className="textcenter">
            <Link to="/login">Back to login </Link>
          </div>
          <div style={classes.recieveCodeText}>
            <span>
              Didn't received code?{" "}
              <a
                href="/verify-account"
                style={
                  disableResendCode
                    ? classes.disableResend
                    : classes.enableResend
                }
                onClick={(event) => resendCode(event)}
              >
                Resend Code
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const verificationValidationSchema = () => {
  return Yup.object().shape({
    code: Yup.string().min(4).required(),
  });
};
